import * as React from "react";
import {Button} from "./button";

export const AsyncButtonWithSpinner = ({
                                           onPress,
                                           children,
                                           ...restProps
                                       }) => {
    const [isLoading, setLoading] = React.useState(false)

    return <Button loading={isLoading} onPress={async () => {
        setLoading(true)
        await onPress()
        setLoading(false)
    }} {...restProps}>
        {children}
    </Button>
}